import {
  Button,
  Divider,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Show,
} from '@chakra-ui/react'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'

import { naturalResolutionMap } from '~shared-components/chakra-theme/foundations/breakpoints'
import { toggleSidebarFiltersAction } from '~shared-components/filters/filter.actions'
import { FilterEndpoint } from '~shared-components/filters/filter.reducers'
import { FilterSelector } from '~shared-components/filters/filter.selector'
import { useTranslations } from '~shared-components/hooks/useTranslations'
import { IconFilter } from '~shared-components/icons/brand/IconFilter'
import { LocationSelector } from '~shared-components/redux/selectors/location.selector'

export const MobileFilterPopover: React.FC = ({ children }) => {
  const dispatch = useDispatch()
  const t = useTranslations()
  const pageType = useSelector(LocationSelector.pageType)
  const numberActiveFilters: number =
    useSelector(
      FilterSelector.numberActiveFiltersByEndpoint(pageType as FilterEndpoint),
    ) || 0
  const { toggleFilterState } = bindActionCreators(
    { toggleFilterState: toggleSidebarFiltersAction },
    dispatch,
  )

  return (
    <Show below={naturalResolutionMap['tablet']}>
      <Popover arrowSize={20} eventListeners={false} offset={[0, 14]}>
        {({ isOpen, onClose }) => (
          <>
            <PopoverTrigger>
              <Button
                alignContent="center"
                borderColor="neutral.30"
                data-analyticsid="close-open-mobile-filters"
                leftIcon={
                  <IconFilter
                    boxSize="16px"
                    marginRight={numberActiveFilters ? undefined : -2}
                  />
                }
                px={2}
                size="md"
                variant="outline"
              >
                {numberActiveFilters || undefined}
              </Button>
            </PopoverTrigger>

            <Flex
              background="var(--chakra-colors-blackAlpha-600)"
              display={isOpen ? 'block' : 'none'}
              height="100vh"
              left="0px"
              position="fixed"
              top="0px"
              width="100vw"
              zIndex={10}
            />
            <PopoverContent
              _focus={{ boxShadow: 'none', outline: 'none' }}
              border="1px solid"
              borderColor="neutral.20"
              boxShadow="none"
              mx={3}
              width="calc(100vw - 24px)"
              zIndex="var(--chakra-zIndices-overlay)"
            >
              <PopoverArrow bgColor="white.0" />
              <PopoverBody bgColor="white.0">
                {children}
                <Divider my={5} />
                <Button
                  _focus={{ boxShadow: 'none' }}
                  alignContent="center"
                  color="white"
                  data-analyticsid="apply-mobile-filters"
                  onClick={() => {
                    toggleFilterState()
                    onClose()
                  }}
                  px={4}
                  size="md"
                  variant="solid"
                  width="100%"
                >
                  {t('filter.apply')}
                </Button>
              </PopoverBody>
            </PopoverContent>
          </>
        )}
      </Popover>
    </Show>
  )
}
